import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-monthwise',
  templateUrl: './monthwise.component.html',
  styleUrls: ['./monthwise.component.scss'],
})
export class MonthwiseComponent implements OnInit {
  monthwisedata;
  today;
  startDate;
  endDate;
  monthwiselist = [];
  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
  ];
  totalth = 0;
  finalData = [];
  appliedFilters: any = {}; 

  constructor(
    private dialogref: MatDialogRef<MonthwiseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.monthwisedata = this.data['monthwisedata'];
    // console.log(this.monthwisedata);

    this.startDate = this.data['startdate'];
    this.endDate = this.data['enddate'];
    this.today = formatDate(new Date(), 'yyyy/MM/dd', 'en-IN', 'GMT+0530');

    //  this.today = new Date().toLocaleString('mr-IN', { month: 'long' });

     console.log(this.today)

     this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);

    let data = this.uniqueData(this.monthwisedata, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        // if (
        //   data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
        //   data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
        //   data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
        //   data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
        //   data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
        // ) {
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 3 + 4;
    this.totalth = this.subTypesName.filter(sub => sub.isVisible).length * 4 + 4;

    // this.getmonthwiselist();
    this.setData();
  }

  //OLD CODE 
//   setData() {
//     // console.log(this.rojmelData);
//     // let uniqueDateData = this.uniqueData(this.monthwisedata, (a) =>
//     //   formatDate(a.crdt_voucher_date, 'MMMM', 'en-IN', 'GMT+0530')
//     // );

//     let uniqueDateData = this.uniqueData(this.monthwisedata, (a) => {
//   let date = new Date(a.crdt_voucher_date);
//   return date.toLocaleString('mr-IN', { month: 'long' });
// })

//     uniqueDateData.sort((a: any, b: any) => {
//       return (
//         new Date(a.crdt_voucher_date).getTime() - new Date(b.crdt_voucher_date).getTime()
//       );
//     });
//     // console.log(
//     // );
//     let finalTotal = {};
//     this.subTypesName.map((b: any, i) => {
//       if (b.isVisible) {
//         let name = this.getKey(b.name);
//         finalTotal[name + '_एकूण'] = 0;
//         finalTotal[name + '_नवीन'] = 0;
//         finalTotal[name + '_नूतनीकरण'] = 0;
//         if (i == 0) {
//           finalTotal['name'] = 'एकूण';
//           finalTotal['एकूण'] = 0;
//           finalTotal['नवीन'] = 0;
//           finalTotal['नूतनीकरण'] = 0;
//         }
//       }
//     });

//     for (let i = 0; i < uniqueDateData.length; i++) {
//       let datewiseData = this.monthwisedata.filter((a) => {
//         return (
//           formatDate(a.crdt_voucher_date, 'MMMM', 'en-IN', 'GMT+0530') ===
//           formatDate(
//             uniqueDateData[i]['crdt_voucher_date'],
//             'MMMM',
//             'en-IN',
//             'GMT+0530'
//           )
//         );
//       });

      
//       // console.log(datewiseData);
//       let totalData = {};
//       this.subTypesName.map((b: any, i) => {
//         if (b.isVisible) {
//           let name = this.getKey(b.name);
//           totalData[name + '_एकूण'] = 0;
//           totalData[name + '_नवीन'] = 0;
//           totalData[name + '_नूतनीकरण'] = 0;
//           if (i == 0) {
//             totalData['एकूण'] = 0;
//             totalData['नवीन'] = 0;
//             totalData['नूतनीकरण'] = 0;
//           }
//         }
//       });
//       datewiseData.map((a: any, i) => {
//         if (i == 0) totalData['entry_date'] = a.entry_date;
//         let name = this.getKey(a.subscription_type);
//         //   let date=new Date(a.crdt_voucher_date);
//         // totalData['crdt_voucher_date']=date.toLocaleString('mr-IN', { month: 'long' })
//         totalData['crdt_voucher_date']=a.crdt_voucher_date

//         totalData[name + '_एकूण'] += parseInt(a.total_amt);
//         finalTotal[name + '_एकूण'] += parseInt(a.total_amt);
//         totalData[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
//         finalTotal[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
//         totalData[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
//         finalTotal[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
//         totalData['एकूण'] += parseInt(a.total_amt);
//         finalTotal['एकूण'] += parseInt(a.total_amt);
//         totalData['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
//         finalTotal['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
//         totalData['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
//         finalTotal['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
//       });
//       // datewiseData.push(totalData);
//       this.finalData.push(totalData);
//     }
//     this.finalData.push(finalTotal);
//     console.log(this.finalData);
    

//     const filteredData = this.finalData.filter(item => item.crdt_voucher_date);

//     // Group by month and year
//     const monthlyTotals: { [key: string]: any } = {};

//     filteredData.forEach(item => {
//       const date = new Date(item.crdt_voucher_date);
//       const yearMonth = `${date.getFullYear()}-${date.getMonth() + 1}`;

//       if (!monthlyTotals[yearMonth]) {
//         monthlyTotals[yearMonth] = {
//           'crdt_voucher_date':0,
//           'वार्षिक_एकूण': 0,
//           'वार्षिक_नवीन': 0,
//           'वार्षिक_नूतनीकरण': 0,
//           'एकूण': 0,
//           'नवीन': 0,
//           'नूतनीकरण': 0,
//           'त्रैवार्षिक_एकूण': 0,
//           'त्रैवार्षिक_नवीन': 0,
//           'त्रैवार्षिक_नूतनीकरण': 0,
//           'पंचवार्षिक_एकूण': 0,
//           'पंचवार्षिक_नवीन': 0,
//           'पंचवार्षिक_नूतनीकरण': 0,
//           'रा.स्व.संघ_ग्रंथ_एकूण': 0,
//           'रा.स्व.संघ_ग्रंथ_नवीन': 0,
//           'रा.स्व.संघ_ग्रंथ_नूतनीकरण': 0
//         };
//       }

//       // Aggregate data
//       monthlyTotals[yearMonth]['crdt_voucher_date'] = item['crdt_voucher_date'] || 0;
//       monthlyTotals[yearMonth]['वार्षिक_एकूण'] += item['वार्षिक_एकूण'] || 0;
//       monthlyTotals[yearMonth]['वार्षिक_नवीन'] += item['वार्षिक_नवीन']|| 0;
//       monthlyTotals[yearMonth]['वार्षिक_नूतनीकरण'] += item['वार्षिक_नूतनीकरण'] || 0;
//       monthlyTotals[yearMonth]['एकूण'] += item['एकूण'] || 0;
//       monthlyTotals[yearMonth]['नवीन'] += item['नवीन'] || 0;
//       monthlyTotals[yearMonth]['नूतनीकरण'] += item['नूतनीकरण'] || 0;
//       monthlyTotals[yearMonth]['त्रैवार्षिक_एकूण'] += item['त्रैवार्षिक_एकूण'] || 0;
//       monthlyTotals[yearMonth]['त्रैवार्षिक_नवीन'] += item['त्रैवार्षिक_नवीन'] || 0;
//       monthlyTotals[yearMonth]['त्रैवार्षिक_नूतनीकरण'] += item['त्रैवार्षिक_नूतनीकरण'] || 0;
//       monthlyTotals[yearMonth]['पंचवार्षिक_एकूण'] += item['पंचवार्षिक_एकूण'] || 0;
//       monthlyTotals[yearMonth]['पंचवार्षिक_नवीन'] += item['पंचवार्षिक_नवीन'] || 0;
//       monthlyTotals[yearMonth]['पंचवार्षिक_नूतनीकरण'] += item['पंचवार्षिक_नूतनीकरण'] || 0;
//       monthlyTotals[yearMonth]['रा.स्व.संघ_ग्रंथ_एकूण'] += item['रा.स्व.संघ_ग्रंथ_एकूण'] || 0;
//       monthlyTotals[yearMonth]['रा.स्व.संघ_ग्रंथ_नवीन'] += item['रा.स्व.संघ_ग्रंथ_नवीन'] || 0;
//       monthlyTotals[yearMonth]['रा.स्व.संघ_ग्रंथ_नूतनीकरण'] += item['रा.स्व.संघ_ग्रंथ_नूतनीकरण'] || 0;
//     });

//     const resultList = Object.values(monthlyTotals);
//     const lastItem = this.finalData[this.finalData.length - 1];
//     console.log(resultList)
//     this.finalData=[]
//     this.finalData=resultList
//     this.finalData.push(lastItem)
//     this.isLoading = false;
//   }

setData() {
  
  const uniqueDateData = this.uniqueData(this.monthwisedata, (a) => {
    const date = new Date(a.crdt_voucher_date);
    return `${date.getFullYear()}-${date.getMonth()}`;
  });

  uniqueDateData.sort((a: any, b: any) => {
    const dateA = new Date(a.crdt_voucher_date);
    const dateB = new Date(b.crdt_voucher_date);
    return dateA.getTime() - dateB.getTime();
  });

  let finalTotal: any = {};
  finalTotal['name'] = 'एकूण';
  finalTotal['एकूण'] = 0;
  finalTotal['नवीन'] = 0;
  finalTotal['नूतनीकरण'] = 0;

  this.subTypesName.forEach((b: any, i) => {
    if (b.isVisible) {
      const name = this.getKey(b.name);
      finalTotal[name + '_एकूण'] = 0;
      finalTotal[name + '_नवीन'] = 0;
      finalTotal[name + '_नूतनीकरण'] = 0;
      if (i === 0) {
        finalTotal['name'] = 'एकूण';
        finalTotal['एकूण'] = 0;
        finalTotal['नवीन'] = 0;
        finalTotal['नूतनीकरण'] = 0;
      }
    }
  });

  this.finalData = [];

  for (let i = 0; i < uniqueDateData.length; i++) {
    const crdtVoucherDate = (uniqueDateData[i] as { crdt_voucher_date: string }).crdt_voucher_date;

    const current = new Date(crdtVoucherDate);
    if (isNaN(current.getTime())) {
      console.error('Invalid date:', crdtVoucherDate);
      continue; 
    }

    const currentMonth = current.getMonth();
    const currentYear = current.getFullYear();
    const currentMonthLabel = current.toLocaleString('mr-IN', { month: 'long' });

    const datewiseData = this.monthwisedata.filter((a) => {
      const d = new Date(a.crdt_voucher_date);
      return d.getMonth() === currentMonth && d.getFullYear() === currentYear;
    });

    let totalData: any = { crdt_voucher_date: currentMonthLabel };
    totalData['एकूण'] = 0;
    totalData['नवीन'] = 0;
    totalData['नूतनीकरण'] = 0;

    this.subTypesName.forEach((b: any, i) => {
      if (b.isVisible) {
        const name = this.getKey(b.name);
        totalData[name + '_एकूण'] = 0;
        totalData[name + '_नवीन'] = 0;
        totalData[name + '_नूतनीकरण'] = 0;
        if (i === 0) {
          totalData['एकूण'] = 0;
          totalData['नवीन'] = 0;
          totalData['नूतनीकरण'] = 0;
        }
      }
    });

    datewiseData.forEach((a: any, i) => {
      if (i === 0) totalData['entry_date'] = a.entry_date;
      const name = this.getKey(a.subscription_type);

      totalData[name + '_एकूण'] += parseInt(a.total_amt);
      finalTotal[name + '_एकूण'] += parseInt(a.total_amt);
      totalData[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
      finalTotal[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
      totalData[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
      finalTotal[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

      totalData['एकूण'] += parseInt(a.total_amt);
      finalTotal['एकूण'] += parseInt(a.total_amt);
      totalData['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
      finalTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
      totalData['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
      finalTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
    });

    this.finalData.push(totalData);
  }

  this.finalData.push(finalTotal);

  this.isLoading = false;
}

  getKey(name) {
    return name.replaceAll(' ', '_');
  }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

   show = false
 printPage() {
  this.show = true;
  const printContent = document.getElementById('print-section')?.outerHTML;
  if (!printContent) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
          @media print {
  @page {
    size: A3 landscape;
    margin: 5mm; /* Reduced margin for more space */
  }

  html, body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    font-size: 12px; /* Slightly reduced for more data visibility */
    line-height: 1.2;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  table {
    width: 100%;
    
    border-collapse: collapse;
    table-layout: fixed;
    page-break-inside: avoid;
  }

  th, td {
    padding: 2px;
    border: 1px solid black;
    text-align: center;
    font-size: 12px;
    line-height: 1.2;
  }

  .noPrint {
    display: none !important;
  }

  div, tr, td, th, tbody, thead, tfoot {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  #print-section {
    page-break-after: avoid;
    break-after: avoid;
  }
}

          </style>
        </head>
        <body>
          <div id="print-section">
            ${printContent}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}


//As per Data Print Data  
// printPage() {
//   this.show = true;

//   const printContent = document.getElementById('print-section')?.outerHTML;
//   if (!printContent) {
//     console.error("Print section not found!");
//     return;
//   }

//   const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

//   if (printWindow) {
//     printWindow.document.open();
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Report</title>
//           <style>
//             @media print {
//               @page {
//                 size: A3 landscape;
//                 margin: 5mm;
//               }

//               html, body {
//                 width: 100%;
//                 height: 100%;
//                 margin: 0;
//                 padding: 0;
//                 font-family: Arial, sans-serif;
//                 font-size: 12px;
//                 line-height: 1.2;
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//               }

//               body {
//                 display: flex;
//                 flex-direction: column;
//                 justify-content: stretch;
//                 min-height: 100vh;
//               }

//               table {
//                 width: 100%;
//                 border-collapse: collapse;
//                 table-layout: fixed;
//                 page-break-inside: avoid;
//               }

//               th, td {
//                 padding: 2px;
//                 border: 1px solid black;
//                 text-align: center;
//                 font-size: 12px;
//                 line-height: 1.2;
//               }

//               .noPrint {
//                 display: none !important;
//               }

//               div, tr, td, th, tbody, thead, tfoot {
//                 page-break-inside: avoid !important;
//                 break-inside: avoid !important;
//               }

//               #print-section {
//                 flex-grow: 1;
//                 page-break-after: avoid;
//                 break-after: avoid;
//                 min-height: 100vh;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div id="print-section">
//             ${printContent}
//           </div>
//           <script>
//             window.onload = function() {
//               window.print();
//               setTimeout(() => { window.close(); }, 500);
//             };
//           </script>
//         </body>
//       </html>
//     `);
//     printWindow.document.close();
//   } else {
//     console.error("Failed to open print window.");
//   }
// }

}
